import styled from '@emotion/styled';

import { COLOR_TEXT_MUTED } from './utils/variables';

export const EmptyState = styled.div`
  padding: 40px 24px;
  text-align: center;
  color: ${COLOR_TEXT_MUTED};
  font-size: 14px;
`;
